import ReportList from './ReportList';

export default {
    list: ReportList
}